import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { authClient } from 'api/apiClient';
import { ecommerceBaseUrl } from 'config/apiConfig';
import { getDefaultCompanyId } from 'utils/helpers';

interface SecretKeys {
    secretKey: string;
    email: string;
}

interface SecretInfo {
    secretInfo: SecretKeys;
    loading: boolean;
    error: string;
}

const initialState: SecretInfo = {
    secretInfo: {
        secretKey: '',
        email: '',
    },
    loading: true,
    error: '',
};
export const updateNotificationEmail = createAsyncThunk(
    'notificationEmail/updateNotificationEmail',
    async (email: string, { getState, dispatch }) => {
        const state: any = getState();
        const companyId = getDefaultCompanyId(state);
        const payload = {
            companyId,
            email,
        };
        const response: any = await authClient.put(
            `${ecommerceBaseUrl}/updateNotificationEmail`,
            { ...payload },
            { 'Content-Type': 'application/json' }
        );
        dispatch(fetchSecretInfo());
        return response;
    }
);

export const generateSecretKey = createAsyncThunk('secretKey/generateSecretKey', async (email: string, { getState, dispatch }) => {
    const state: any = getState();
    const companyId = getDefaultCompanyId(state);
    const payload = {
        companyId,
        email,
    };
    const response: any = await authClient.post(
        `${ecommerceBaseUrl}/generateSharedSecretKey`,
        { ...payload },
        { 'Content-Type': 'application/json' }
    );
    dispatch(fetchSecretInfo());
    return response;
});

export const fetchSecretInfo = createAsyncThunk('secretInfo/fetchSecretInfo', async (_, { getState }) => {
    const state: any = getState();
    const companyId = getDefaultCompanyId(state);
    const response: any = await authClient.get(`${ecommerceBaseUrl}/getSharedSecretKey`, {
        headers: {
            companyId,
            hideToast: true,
        },
    });
    return response;
});

const secretInfoSlice = createSlice({
    name: 'secretInfo',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchSecretInfo.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchSecretInfo.fulfilled, (state, action) => {
            state.loading = false;
            if (!action?.payload) return;
            state.secretInfo.secretKey = action?.payload?.secret || '';
            state.secretInfo.email = action?.payload?.email || '';
        });
        builder.addCase(fetchSecretInfo.rejected, (state) => {
            state.loading = false;
        });
    },
});

export default secretInfoSlice.reducer;
